export const DEFAULT_FORMAT = 'ddd DD MMM YYYY HH:mm'
export const DEFAULT_DATE_FORMAT = 'ddd DD MMM YYYY'
export const DEFAULT_DATE_ISO_FORMAT = 'DD.MM.YYYY'
export const DEFAULT_TIME_ISO_FORMAT = 'HH:mm'
